<template>
  <router-view ref="page" v-else/>
</template>
<script>
export default {
  name: 'EmptyPageView'
}
</script>
